(function () {
  'use strict';

  /* @ngdoc object
   * @name subsistemes.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.permisos', [
      'ui.router'
    ]);
}());